import React from 'react';
import { Typography } from 'seagull';
export default function LoadingIndicator(_ref) {
  let {
    testid = 'loading-indicator'
  } = _ref;
  return /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid
  }, "Loading...");
}